export default __webpack_public_path__ + "static/media/txt_entrance_02.24a9b31d.svg";